<template lang="pug">
v-dialog(
  v-model="dialog"
  fullscreen
  hide-overlay
  transition="dialog-bottom-transition"
)
  v-card(v-if="selectedDay")
    v-toolbar
      v-toolbar-title.mr-auto.d-flex.align-center
        v-chip(color="primary" label).mr-2 {{ sortedSchedules.length }}
        | Вебинары на {{ selectedDay | readableDate }}
      v-toolbar-items
        v-btn(@click="dialog = false" color="error")
          v-icon mdi-close
    v-card-text
      v-card.pa-4.mt-4(
        outlined
        v-for="(schedule, index) in sortedSchedules"
        :key="index"
      )
        v-chip.time-day(label color="accent").font-weight-bold.mr-2
          | {{ schedule.start_at | readableTime }} -  {{ schedule.end_at | readableTime }}
        .d-flex.align--center
          v-chip.mr-2(outlined label) {{ cachedProject(schedule.project_id).name }}
          p.title Название вебинара: {{ schedule.name }}
        p.caption(v-if="schedule.user_full_name") {{ schedule.user_full_name }}

        p(v-if="schedule.url")
          | Ссылка: &nbsp;
          a(:href="schedule.url") {{ schedule.url }}

        p(v-if="schedule.dispatcher_user_ids.length")
          | Организации: &nbsp;
          v-chip.mr-2(color="success" label v-for="organization_id in schedule.dispatcher_user_ids" :key="organization_id")
            | {{ getOrganization(organization_id).name }}

        p(v-if="schedule.roles_name.length") Роли:
          v-chip(
            v-for="role in schedule.roles_name"
            label
            color="primary"
            :key="role"
          ).ml-2 {{ role }}

        p Ведет:
          span(v-if="schedule.user_full_name")  {{ schedule.user_full_name }}
          v-chip(v-else label :color="schedule.user_id === user.id ? 'warning' : 'primary'").ml-2
           | {{ cachedUser(schedule.user_id).username }}

        p(v-if="schedule.region_id")
          | Регион: {{ cachedRegion(schedule.region_id).name }}
        p(v-if="schedule.municipality_id")
          | Муниципалитет: {{ cachedMunicipality(schedule.municipality_id).name }}

</template>
<script>
import { mapGetters } from 'vuex';
import mixinDateTime from '@/mixins/mixinDateTime';
import isSameDay from 'date-fns/isSameDay';

export default {
  mixins: [mixinDateTime],
  props: {
    schedules: { type: Array, required: true },
    selectedDay: { type: [Date], required: false, default: null },
    getOrganization: { type:Function, required:true },
  },
  data() {
    return {
      dialog: false,
      users: [],
    };
  },
  computed: {
    ...mapGetters({
      cachedMunicipality: 'cache/cachedMunicipality',
      cachedRegion: 'cache/cachedRegion',
      cachedUser : 'cache/cachedUser',
      cachedProject : 'cache/cachedProject',
      user : 'auth/getUser',
    }),
    sortedSchedules() {
      const filtered =  this.schedules.filter((schedule) => isSameDay(new Date(schedule.start_at), this.selectedDay));
      return filtered.sort((a, b) => new Date(a.start_at) > new Date(b.start_at));
    },
  },
  watch:{
    selectedDay(v) {
      if (v) this.dialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  width: 100%;
}

.time-day {
  position: absolute;
  top: 0px;
  right: -8px;
}
</style>>
